//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'CO_ultrasound',
  data () {
    return {
      defaultJson: {
        'LVOT VTI': 'LVOT VTI',
        'Heart Rate': '心率',
        'Left Ventricular Outflow Tract Diameter': '左室流出道直径',
        'Stroke Volume': '每搏输出量',
        'Time Velocity Integral': '左室流出道速率时间积分',
        'Cardiac Index': '心指数',
        'Cardiac Output': '心输出量',
        'BSA': 'BSA',
        'LVOT Diameter': 'LVOT 直径'
      },
      form: {
        diam: '',
        itv: '',
        fc: '',
        bsa: ''

      },
      contentDescription: '',
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: '0', name: '男' },
        { value: '5', name: '女' }
      ],
      sv: '...',
      co: '...',
      ci: '...'
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let sv = Math.PI * form.diam * form.diam * form.itv / 4
        let co = Math.PI * form.diam * form.diam * form.itv * form.fc / 4000
        self.ci = (co / form.bsa).toFixed(1)
        let result = self.ci
        self.sv = sv.toFixed(0)
        self.co = co.toFixed(1)

        self.hasScore = true
        return String(result)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/CO_ultrasound.vue